export class AuthSSO {
  constructor(
    public lookupkey: string,
    public password: string,
    public twofacode: string,
  ) {}
}
